export const buttonScrollToTopMixin = {
  data () {
    return {
      buttonIsVisible: false
    }
  },
  methods: {
    goToTop (args) {
      window.scrollTo({
        top: args,
        behavior: 'smooth'
      })
    },
    handleScroll () {
      this.buttonIsVisible = window.scrollY > 200
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
